<app-mfa-management-dialog
        *ngIf="!verified()"
        mode="password-change"
        (verified)="onPasswordVerified()"
        (dialogClose)="back.emit()">
</app-mfa-management-dialog>

<ng-container *ngIf="verified()">
<app-wait *ngIf="!doneLoading"></app-wait>

<app-message-box [content]="errors"></app-message-box>

<div *ngIf="doneLoading && !loadingError" class="information">

    <h3 class="suif-h3">Security Questions</h3>

    <div class="suif-body-copy">
        Add security questions to safeguard access to your account.  We'll prompt you with these questions if you
        need to recover your account.
        <ng-container *ngIf="accountSettings === 'reset'">
            If you click Cancel, it will retain your existing security questions.
        </ng-container>
    </div>

    <app-message-box level="caution" class="disclaimer">
        <span class="initial-emphasis">important:</span> When recovering your account, your answers must match
        <span class="mid-sentence-emphasis">exactly</span> the way you enter them here, including any capital letters
        and spaces
    </app-message-box>

    <form [formGroup]="formData" autocomplete="off">
        <app-select label="Security Question 1" [list]="securityQuestionsForQuestion1" code="value" fieldId="question-1"
                    (change)="filterQuestions()"
                    formControlName="question1" placeholder="Select a question"
                    [errors]="formData.controls.question1.errors?.question1" isRequired></app-select>

        <app-input label="Answer 1" formControlName="answer1" fieldId="answer-1" isRequired [maxlength]="80"
                   [errors]="formData.controls.answer1.errors?.answer1"></app-input>

        <app-select label="Security Question 2" [list]="securityQuestionsForQuestion2" code="value" fieldId="question-2"
                    (change)="filterQuestions()"
                    formControlName="question2" placeholder="Select a question"
                    [errors]="formData.controls.question2.errors?.question2 || errors.fieldErrors.question2" isRequired></app-select>

        <app-input label="Answer 2" formControlName="answer2" fieldId="answer-2" isRequired [maxlength]="80"
                   [errors]="formData.controls.answer2.errors?.answer2"></app-input>

        <app-select label="Security Question 3" [list]="securityQuestionsForQuestion3" code="value" fieldId="question-3"
                    (change)="filterQuestions()"
                    formControlName="question3" placeholder="Select a question"
                    [errors]="formData.controls.question3.errors?.question3 || errors.fieldErrors.question3" isRequired></app-select>

        <app-input label="Answer 3" formControlName="answer3" fieldId="answer-3" isRequired [maxlength]="80"
                   [errors]="formData.controls.answer3.errors?.answer3"></app-input>

        <div *ngIf="!accountSettings" class="button-row">
            <button *ngIf="workflow" type="button" class="btn btn-secondary" (click)="back.emit('back')">Back</button>
            <app-wait-button (onClick)="saveQuestions()" cssClass="btn btn-verty" [waiting]="submitting" label="{{workflow ? 'Save & Continue' : 'Save'}}"></app-wait-button>
        </div>
        <div *ngIf="accountSettings" class="button-row">
            <button type="button" class="btn btn-secondary" (click)="back.emit()">Cancel</button>
            <app-wait-button (onClick)="saveQuestions()" [waiting]="submitting" label="Save"></app-wait-button>
        </div>
    </form>
</div>
</ng-container>
